import { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../CSS/NewOnboading/QrReadySucces.css";
import { handleError } from "../../../CommonJquery/CommonJquery";
import {
  custom_qr_manage,
  server_post_data,
  get_all_data_onboarding,
} from "../../../ServiceConnection/serviceconnection";
import { storeData } from "../../../LocalConnection/LocalConnection";
import { useSelector } from "react-redux";
import QRCodeStyling from "qr-code-styling";
import { Eye, SquareUserRound, X, ArrowRight } from "lucide-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Download, Share2, LayoutDashboard, ChevronDown } from "lucide-react";
import brand_logo from "../../../Assets/brand_logo.png";
import dummyBussinesLogo from "../../../Assets/dummyBussinesLogo.png";
import CelebrationScreen from "./CelebrationScreen";
import OnboardingLoader from "../Pages/OnboadingLoader";
import SuccessPageLoader from "./SuccessPageLoader";
import { useLocation } from "react-router-dom";
import Temp1 from "../Templates/temp1";
import Temp2 from "../Templates/temp2";
import Temp3 from "../Templates/temp3";
import { FALSE } from "sass";
import { v4 as uuidv4 } from "uuid";
export default function QrReadySucces() {
  const navigate = useNavigate();
  const templateData = useSelector((state) => state.step.templateData);
  const location = useLocation();
  let bus_id=0;
  // QR Code refs
  const qrCodeRef = useRef(null);
  const modalQrCodeRef = useRef(null);
  const qrInstance = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("id");
  const cus_id = queryParams.get("cus_id");
  const sub_id = queryParams.get("sub_id");
  const [format, setFormat] = useState("png");
  const [size, setSize] = useState("small");
  const [email, setEmail] = useState("");
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [selectedPattern, setSelectedPattern] = useState("");
  const [selectedFrame, setSelectedFrame] = useState("frameBox1");
  const [styles, setStyles] = useState({
    backgroundColor: "#ffffff",
    textColor: "#000000",
    ctaColor: "#ff5722",
  });
  const [showModal, setShowModal] = useState(false);
  const [logo, setLogo] = useState(null);
  const [logoweb, setLogoweb] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [logourl, setLogourl] = useState("");
  const [bgColor, setBgColor] = useState("#fff");
  const [textColor, setTextColor] = useState("#333");
  const [qrCodeImage, setqrCodeImage] = useState("");
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [bussinesText, setbussinesText] = useState("Adidas Pvt. Ltd.");
  const [tagLine, settagLine] = useState("Best Shop in Town");
  const [URLLINK, setURLLINK] = useState("Best Shop in Town");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ NEW: Celebration and Animation States
  const [showCelebration, setShowCelebration] = useState(true);
  const [showSuccessText, setShowSuccessText] = useState(false);
  const [showQRCard, setShowQRCard] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [activeTemplateId, setActiveTemplateId] = useState("1");
  // Mobile Screen states
  const rightFileInputRef = useRef(null);
  const [ctaHeading, setCtaHeading] = useState("If you had a bad experience!");
  const [ctaText, setCtaText] = useState("Contact Manager");
  const [headingText, setHeadingText] = useState("Your Feedback Matters!");
  const [subheadingText, setSubheadingText] = useState(
    "Enjoyed your experience? Share your reviews on your favorite platform below!",
  );
  const [ctaHeading1, setCtaHeading1] = useState("Good Experience");
  const [ctaText1, setCtaText1] = useState("Needs Improvement");

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  // Size dimensions mapping based on use case
  const sizeDimensions = {
    small: {
      width: 180,
      height: 180,
      description: "Tabletop QR Stand (3x3 inches)",
    },
    medium: {
      width: 300,
      height: 300,
      description: "Exit Stand Display (5x5 inches)",
    },
    large: {
      width: 600,
      height: 600,
      description: "Indoor Hoarding (10x10 inches)",
    },
  };
  const TEMPLATES = [
    {
      id: "6",
      name: "Template 1",
      component: Temp1,
    },
    {
      id: "2",
      name: "Template 2",
      component: Temp2,
    },
    {
      id: "1",
      name: "Template 3",
      component: Temp3,
    },
  ];
  // ✅ NEW: Handle celebration end with fast timing
  const handleCelebrationEnd = () => {
    setShowCelebration(false);
    setShowSuccessText(true);

    // Show QR card 1 second after text change
    setTimeout(() => {
      setShowQRCard(true);
    }, 1000);
  };

  // Animation variants for staggered animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0,
        delayChildren: 0,
      },
    },
  };

  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setShowModal(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("new_bus_id", bus_id);
    await server_post_data(custom_qr_manage, fd)
      .then((Response) => {
        console.log("nd", Response);
        const data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log("fdsbjkbdjkbfksdb", final_data.User_Data.theme_other_id);
          setURLLINK(final_data.url_link_go);
          setBgColor(final_data.User_Data.application_color);
          setTextColor(final_data.User_Data.application_text_color);
          setLogoweb(final_data.User_Data.website_logo);
          setbussinesText(final_data.User_Data.business_name);
          settagLine(final_data.User_Data.business_tagline);
          setSelectedFrame(final_data.User_Data.frame_name);
          setSelectedPattern(final_data.User_Data.parttan_name);
          setLogo(final_data.full_logo_url);
          setLogourl(final_data.user_linkss_link);
          setqrCodeImage(final_data.qr_image_base64);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
          setActiveTemplateId(final_data.User_Data.theme_other_id);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  console.log("Hey man", activeTemplateId);

  const master_data_get_1 = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "9");
    fd.append("payment_id", paymentId ?? uuidv4());
    fd.append("cus_id", cus_id ?? uuidv4());
    fd.append("sub_id", sub_id ?? uuidv4());
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          const data_get = final_data.data_get[0];
          const user_linkss_link = final_data.user_linkss_link;
          const url_link_go = final_data.url_link_go;
          storeData("final_full_name", data_get.manager_name);
          storeData("final_user_email", data_get.bus_email);
          storeData("final_bus_id", data_get.bus_id);
          bus_id=data_get.bus_id;
          storeData("user_image", data_get.website_logo);
          storeData("price_amount_package", data_get.package_amount);
          storeData("counter_bus_id", data_get.bus_counter);
          storeData("url_link_go", url_link_go);
          storeData("user_image_path", user_linkss_link);

          setbusinessTypes(data_get);
          setHeadingText(data_get.heading_text);
          setSubheadingText(data_get.subheading_text);
          setCtaHeading(data_get.cta_heading);
          setCtaText(data_get.cta_text);
          setLogo(
            final_data.review_linkss_link + data_get.website_logo,
          );
          setbussinesText(data_get.business_name);
          settagLine(data_get.business_tagline);

          setBgColor(data_get.application_color);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2( final_data.review_linkss_link2);
          setbusinessImage(final_data.review_linkss_link);
          setStyles({
            ...styles,
            backgroundColor: data_get.application_color,
            textColor: isLightColor(data_get.application_color)
              ? "#000000"
              : "#FFFFFF",
          });
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  const isLightColor = ({ r, g, b }) => {
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await master_data_get_1(); // Step 1: First call

        // Step 2: Wait for 5 seconds
        await new Promise((resolve) => setTimeout(resolve, 5000));

        await master_data_get(); // Step 3: Second call
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Step 4: Set data loaded regardless of success/failure
        setIsDataLoaded(true);
      }
    };

    const timeout = setTimeout(() => {
      fetchData();
    }, 500); // Optional initial delay

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, []);
  const [canRenderQR, setCanRenderQR] = useState(false);

  useEffect(() => {
    if (showQRCard && isDataLoaded) {
      const timeout = setTimeout(() => setCanRenderQR(true), 200);
      return () => clearTimeout(timeout);
    } else {
      setCanRenderQR(false);
    }
  }, [showQRCard, isDataLoaded]);
  useEffect(() => {
    const createQRCode = (containerRef) => {
      if (!containerRef.current) return;

      containerRef.current.innerHTML = "";

      const currentDotStyle = selectedPattern;
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        shape: selectedFrame === "frameBox circularFrame" ? "circle" : "square",
        data: URLLINK,
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 10,
        },
        dotsOptions: {
          type: currentDotStyle,
          color: "#000",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          color: "#000",
        },
        backgroundOptions: {
          color: "#fff",
        },
      });

      qrCode.append(containerRef.current);

      setTimeout(() => {
        const canvas = containerRef.current.querySelector("canvas");
        if (canvas) {
          canvas.style.width = "100%";
          canvas.style.height = "100%";

          if (selectedFrame === "frameBox circularFrame") {
            canvas.style.borderRadius = "50%";
            canvas.style.clipPath = "circle(50% at center)";
          } else if (selectedFrame === "frameBox") {
            canvas.style.borderRadius = "12px";
            canvas.style.clipPath = "none";
          } else {
            canvas.style.borderRadius = "0";
            canvas.style.clipPath = "none";
          }
        }
      }, 100);

      return qrCode;
    };

    if (canRenderQR && qrCodeRef.current) {
      qrInstance.current = createQRCode(qrCodeRef);
    }

    if (canRenderQR && showModal && modalQrCodeRef.current) {
      createQRCode(modalQrCodeRef);
    }
  }, [canRenderQR, selectedPattern, selectedFrame, logo, showModal]);
  // Custom styles for the frames in the QR display
  const getFrameStyles = () => {
    // Adjust size based on selected size option
    const dimensions = sizeDimensions[size];

    return {
      width: `${dimensions.width}px`,
      height: `${dimensions.height}px`,
      borderRadius:
        selectedFrame === "frameBox circularFrame"
          ? "50%"
          : selectedFrame === "frameBox"
            ? "12px"
            : "0",
      overflow: "hidden",
      backgroundColor: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };
  };

  // Get QR code inner container styles based on size
  const getQrInnerStyles = () => {
    const dimensions = sizeDimensions[size];
    return {
      width: `${dimensions.width - 20}px`,
      height: `${dimensions.height - 20}px`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      borderRadius:
        selectedFrame === "frameBox circularFrame"
          ? "50%"
          : selectedFrame === "frameBox"
            ? "12px"
            : "0",
      clipPath:
        selectedFrame === "frameBox circularFrame"
          ? "circle(50% at center)"
          : "none",
    };
  };

  // download QR Code
  const handleDownload = async (format) => {
    setLoading(true);

    const qrElement = document.getElementById("qrScreenMobilePrint");

    // Ensure all images inside the qrElement are fully loaded
    const images = qrElement.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      if (!img.complete) {
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      }
      return Promise.resolve();
    });

    // Wait until all images are fully loaded
    await Promise.all(promises);

    // Small timeout to ensure styles are applied
    await new Promise((res) => setTimeout(res, 300));

    try {
      const canvas = await html2canvas(qrElement, {
        useCORS: true, // Important for cross-origin images
        allowTaint: true,
        backgroundColor: null, // Retain actual background
        scale: 2, // For higher-quality export
      });

      const logoSrc =
        templateData?.logo || logo || dummyBussinesLogo || "/placeholder.svg";
      const logoImage = new Image();
      logoImage.src = logoSrc;

      logoImage.onload = () => {
        if (format === "png") {
          // Add logo to canvas for PNG
          const ctx = canvas.getContext("2d");
          const logoWidth = 100;
          const logoHeight = 100;
          ctx.drawImage(
            logoImage,
            canvas.width - logoWidth - 10,
            canvas.height - logoHeight - 10,
            logoWidth,
            logoHeight,
          );

          // Create download link for PNG
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `qr_code_${size}.png`;
          link.click();

          setLoading(false);
        } else if (format === "pdf") {
          // Create PDF
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
          });

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const canvasRatio = canvas.height / canvas.width;
          const imgWidth = pdfWidth * 0.8;
          const imgHeight = imgWidth * canvasRatio;
          const x = (pdfWidth - imgWidth) / 2;
          const y = (pdfHeight - imgHeight) / 3;

          // Add business text and tagline
          pdf.setFontSize(16);
          pdf.text(bussinesText, pdfWidth / 2, 20, { align: "center" });
          pdf.setFontSize(12);
          pdf.text(tagLine, pdfWidth / 2, 30, { align: "center" });

          // Add QR code image
          pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);

          // Add size information
          pdf.setFontSize(10);
          pdf.text(
            `Size: ${sizeDimensions[size].description}`,
            pdfWidth / 2,
            pdfHeight - 20,
            { align: "center" },
          );

          // Add logo to PDF
          const logoWidth = 20;
          const logoHeight = 20;
          pdf.addImage(
            logoImage,
            "PNG",
            pdfWidth - logoWidth - 10,
            pdfHeight - logoHeight - 10,
            logoWidth,
            logoHeight,
          );

          // Save the PDF
          pdf.save(`qr_code_${size}.pdf`);
          setLoading(false);
        }
      };

      // Handle logo load error
      logoImage.onerror = () => {
        console.warn("Logo failed to load, proceeding without logo");

        if (format === "png") {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `qr_code_${size}.png`;
          link.click();
        } else if (format === "pdf") {
          // Create PDF without logo
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
          });

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const canvasRatio = canvas.height / canvas.width;
          const imgWidth = pdfWidth * 0.8;
          const imgHeight = imgWidth * canvasRatio;
          const x = (pdfWidth - imgWidth) / 2;
          const y = (pdfHeight - imgHeight) / 3;

          pdf.setFontSize(16);
          pdf.text(bussinesText, pdfWidth / 2, 20, { align: "center" });
          pdf.setFontSize(12);
          pdf.text(tagLine, pdfWidth / 2, 30, { align: "center" });
          pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
          pdf.setFontSize(10);
          pdf.text(
            `Size: ${sizeDimensions[size].description}`,
            pdfWidth / 2,
            pdfHeight - 20,
            { align: "center" },
          );

          pdf.save(`qr_code_${size}.pdf`);
        }

        setLoading(false);
      };
    } catch (err) {
      console.error("Failed to generate image:", err);
      setLoading(false);
    }
  };
  console.log("showSuccessText", showSuccessText);
  const renderActiveTemplate = () => {
    // Get the template from our templates object
    console.log(activeTemplateId);
    const activeTemplate = TEMPLATES.find(
      (template) => template.id === activeTemplateId,
    );

    if (!activeTemplate) {
      console.error(`Template with ID ${activeTemplateId} not found`);
      return null;
    }

    const TemplateComponent = activeTemplate.component;

    let finalCtaHeading = ctaHeading;
    let finalCtatext = ctaText;

    if (activeTemplateId === "2" || activeTemplateId === "3") {
      finalCtaHeading = ctaHeading1;
      finalCtatext = ctaText1;
    } else {
      finalCtaHeading = ctaHeading;
      finalCtatext = ctaText;
    }

    return (
      <TemplateComponent
        logo={logo}
        brand_logo={brand_logo}
        headingText={headingText}
        subheadingText={subheadingText}
        businessTypes2={businessTypes2}
        businessImage2={businessImage2}
        ctaHeading={finalCtaHeading}
        ctaText={finalCtatext}
        styles={styles}
        SquareUserRound={SquareUserRound}
        rightFileInputRef={rightFileInputRef}
      />
    );
  };
  const [MobileQrScreen, setMobileQrScreen] = useState(false);
  const [StandQrScreen, setStandQrScreen] = useState(false);
  const [StandQrScreenbtnShow, setStandQrScreenbtnShow] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleQrScreen = (type) => {
    if (screenWidth > 991) {
      if (type === "mobile") {
        console.log("mobileQrShow");
        setMobileQrScreen(true);
        setStandQrScreen(false);
        setStandQrScreenbtnShow(false);
      } else if (type === "stand") {
        console.log("StandMobileQrShow");
        setStandQrScreen(true);
        setMobileQrScreen(false);
        setStandQrScreenbtnShow(true);
      }
    }
  };

  if (!isDataLoaded) {
    return <OnboardingLoader />;
  }
  return (
    <div className="qr-completion-container">
      {/* <SuccessPageLoader /> */}
      {loading && <OnboardingLoader />}
      {/* ✅ NEW: Fast Celebration with callback */}
      {showCelebration && (
        <CelebrationScreen onCelebrationEnd={handleCelebrationEnd} />
      )}

      <motion.div
        className="container-lg"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="mobilePreviewContainer Sucess_page_preview">
          <button
            type="button"
            className="mobilePreviews"
            onClick={handlePreviewMobile}
          >
            <Eye size={16} />
          </button>{" "}
          <p>Preview</p>
        </div>
        <div className="height_ovr_flow_clss_Succes_page">
          <div className="row justify-content-center">
            <div className="col-12">
              {/* ✅ UPDATED: Main content with text change logic */}
              <AnimatePresence mode="wait">
                {!showSuccessText ? (
                  <motion.div
                    key="initial"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="succes_top_heading"
                  >
                    <h1 className="main-title">
                      {"We’re Loving your Wowreviews"}
                    </h1>
                    <p className="main-subtitle">
                      {
                        "Keep Adding links and customizing it untill it’s perfect-then Share it with the world."
                      }
                    </p>
                  </motion.div>
                ) : (
                  <motion.div
                    key="success"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="succes_top_heading"
                  >
                    <h1 className="main-title">
                      {" "}
                      Success! Your QR Code is Ready{" "}
                    </h1>
                    <p className="main-subtitle">
                      Your custom review QR code has been successfully created
                      and downloaded
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Content Area with Phone and QR Card */}
              <div className="content-area">
                <div className="phone-qr-container ">
                  <div
                    className={`step7Div  ${
                      showSuccessText
                        ? "hide-on-mobile"
                        : "newCardClasssANSmall"
                    } ${
                      MobileQrScreen
                        ? "mobile-qr-active"
                        : "newCardClasssANSmall"
                    } ${StandQrScreen ? "mobile-qr-reset" : ""}`}
                    onClick={() => toggleQrScreen("mobile")}
                  >
                    <motion.div
                      className="Succes_page_Mobile_qr"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        transition: {
                          delay: 0.5,
                          duration: 1,
                        },
                      }}
                    >
                      {renderActiveTemplate()}
                    </motion.div>
                  </div>

                  <AnimatePresence>
                    {showQRCard && (
                      <motion.div
                        className={`qr-card-container  ${
                          MobileQrScreen ? "stand-qr-active" : "newCardClasssAN"
                        } ${
                          StandQrScreen ? "stand-qr-reset" : "newCardClasssAN"
                        }`}
                        onClick={() => toggleQrScreen("stand")}
                      >
                        <div
                          className="step7Div margin_class_qr_ready_page"
                          style={{ position: "relative" }}
                          id="qrScreenMobilePrint"
                        >
                          <div className="qrScreenMobile">
                            <div className="logoSection">
                              <div className="logoCircle">
                                <img
                                  src={
                                    templateData?.logo ||
                                    logo ||
                                    dummyBussinesLogo ||
                                    "/placeholder.svg"
                                  }
                                  className="dummyBussinesLogo"
                                  title="Business Logo"
                                  alt="Logo"
                                />
                              </div>
                              <div className="businessInfo">
                                <h2>{bussinesText}</h2>
                                <p>{tagLine}</p>
                              </div>
                            </div>
                            <div
                              className="feedbackSection"
                              style={{ backgroundColor: bgColor }}
                            >
                              <p style={{ color: textColor }}>
                                Please Provide your valuable
                              </p>
                              <h1 style={{ color: textColor }}>Feedback</h1>
                            </div>
                            <div className="qrCodeContainer">
                              {selectedPattern && selectedPattern !== "" && (
                                <div
                                  className={selectedFrame}
                                  style={{
                                    ...getFrameStyles(),
                                    clipPath:
                                      selectedFrame === "frameBox circularFrame"
                                        ? "circle(50% at center)"
                                        : "none",
                                  }}
                                >
                                  <div
                                    ref={qrCodeRef}
                                    style={getQrInnerStyles()}
                                  />
                                </div>
                              )}
                            </div>

                            <div className="social-icons">
                              {businessTypes2.map((item, index) => {
                                if (index < 4) {
                                  return (
                                    <img
                                      key={index}
                                      src={
                                        businessImage2 + item.review_logo ||
                                        "/placeholder.svg" ||
                                        "/placeholder.svg"
                                      }
                                      alt={item.review_name}
                                      title={item.review_name}
                                    />
                                  );
                                }
                                return null;
                              })}
                            </div>

                            <div className="preview-footer">
                              Powered by Your <span>Wowreviews</span>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </div>
          {/* Action Buttons */}
        </div>
        <AnimatePresence>
          {showQRCard && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: 1.5, duration: 0.5 },
              }}
            >
              <div className="Bttm_Bttns_action ">
                {StandQrScreenbtnShow && (
                  <>
                    <button
                      className="btn action-btn download-btn"
                      style={{ backgroundColor: "var(--primary-600)" }}
                      onClick={() => handleDownload("png")}
                    >
                      <Download size={20} className="btn-icon lucide-download-sss" />
                      <span className="hide_mobile_text">Download</span>
                      PNG
                    </button>
                    <button
                      className="btn action-btn download-btn"
                      style={{ backgroundColor: "var(--primary-600)" }}
                      onClick={() => handleDownload("pdf")}
                    >
                      <Download size={20} className="btn-icon lucide-download-sss" />
                      <span className="hide_mobile_text">Download </span> PDF
                    </button>
                  </>
                )}
              </div>
              <div className="go_to_dash_bttn">
                <Link to="/" className="goDashLink">
                  <span className="hide_mobile_text">Go To </span> Dashboard
                  <ArrowRight className="arrow-icon" />
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
      <Modal
        show={showModal}
        onHide={handlePreviewMobile}
        centered
        backdrop="static"
      >
        <Modal.Body style={{ position: "relative" }}>
          <X
            size={25}
            onClick={handlePreviewMobile}
            className="close_model_div"
          />

          <div className="step7Div">
            <motion.div
              className="Succes_page_Mobile_qr "
              initial={{ opacity: 0, y: 20 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: {
                  delay: 0.5,
                  duration: 1,
                },
              }}
            >
              {renderActiveTemplate()}
            </motion.div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
